import { TypedError } from 'src/reducers/triageSettingsReducer/types';

export const isTypedError = (error: unknown): error is TypedError => {
  return (error as TypedError)?.error_type !== undefined;
};
